export const PICKUP_DAYS_LIST = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const NUMBER_OF_UNIQUE_BIDDERS_LIST = [
  '0',
  '1',
  '1+'
]